const axios = require("axios");

export default class ApiRequest {
  static _url = process.env.REACT_APP_HOST;
  static _default_path = process.env.REACT_APP_API_URL;

  static _create_api_url() {
    return `${this._url}/${this._default_path}`;
  }

  // Axios Instance can be used for calls to always use the settings defined in it
  static get axiosInstance() {
    return axios.create({
      baseURL: this._create_api_url(),
      timeout: 30000,
    });
  }

  // Checks if axios api call was successful
  static callSuccess(response) {
    if (response.status === 200 && response.data.success) {
      return true;
    }

    return false;
  }

  // Call returned 'success' false, because the SELECT couldn't get any results (0 rows)
  static callNoResults(response) {
    if (response.status === 200 && !response.data.success) {
      return true;
    }

    return false;
  }
  // Check if axios api call has records
  static callHasRecords(response) {
    if (response.data.hasOwnProperty("records")) {
      if (response.data.records.length > 0) {
        return true;
      }
    }

    return false;
  }
}
